// The box only shows on hover, or as soon as a selection is running. It sits
// next to the drag handle, never in its place. Shift+click checks the whole
// range from the last checked line.
import React from "react"

const RowCheckbox = ({ checked, onToggle, label }) => (
  <input
    type       = "checkbox"
    checked    = {checked}
    onChange   = {() => {}}
    onClick    = {event => { event.stopPropagation(); onToggle(event.shiftKey) }}
    aria-label = {label}
    className  = {`qb-row-check shrink-0 w-3.5 h-3.5 accent-brand-500 cursor-pointer ${
      checked ? "" : "opacity-0 group-hover:opacity-100"
    }`}
  />
)

export default RowCheckbox
